import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ToolbarModule } from 'primeng/toolbar';
import { ButtonModule } from 'primeng/button';
import { HrFormInputNumberComponent } from './hr-form-inputNumber.component';
import { TranslateModule } from '@ngx-translate/core';
import { HvlFormItemModule } from '@hvlng/framework-core/form';
import { ReactiveFormsModule } from '@angular/forms';
import { PrimengSharedModule } from '@hvlng/framework-core/shared';

@NgModule({
    declarations: [HrFormInputNumberComponent],
    imports: [
        CommonModule,
        ToolbarModule,
        ButtonModule,
        TranslateModule,
        HvlFormItemModule,
        ReactiveFormsModule.withConfig({callSetDisabledState: 'whenDisabledForLegacyCode'}),
        PrimengSharedModule,
    ],
    exports: [HrFormInputNumberComponent],
})
export class HrFormInputNumberModule {}
